import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { ActivitiesGridColumns, ActivitiesGridItem } from 'src/components/ActivitiesGrid';
import { useData } from 'src/pages/ActivitiesPage/hooks';
import DataGrid from 'src/components/DataGrid';
import s from 'src/pages/ActivitiesPage/ActivitiesPage.styles';

const ActivitiesPage = ({ entityId, entityType, onClose }) => {
  const [{ data, loading, refetch, variables }, { onPageChanged }] = useData({
    entityId,
    entityType,
  });

  return (
    <s.InfoOverlay>
      <s.CloseBtn name="cross" onClick={onClose} />
      <s.Title>
        <Trans>ACTIVITY_LOG</Trans>
      </s.Title>
      <s.Box>
        <DataGrid
          data={data}
          gridColumns={() => <ActivitiesGridColumns />}
          gridItem={item => <ActivitiesGridItem key={item.id} item={item} />}
          header={() => null}
          loading={loading}
          name="ActivitiesGrid"
          onPageChanged={onPageChanged}
          paginationUseQuery={false}
          refetch={refetch}
          variables={variables}
        />
      </s.Box>
    </s.InfoOverlay>
  );
};

ActivitiesPage.propTypes = {
  entityId: PropTypes.number,
  entityType: PropTypes.string,
  onClose: PropTypes.func,
};

export default React.memo(ActivitiesPage);
